import { useQuery, useMutation, useQueryClient } from "react-query";
import { dashboardService } from "../api/dashboard.service";
import { IQueryOptions } from ".";

export const useGetDashboardOverview = (options?: IQueryOptions) =>
  useQuery(["dashboard", "overview"], () => dashboardService.getDashboardOverview(), {
    staleTime: 30 * 1000, // 30 seconds
    cacheTime: 5 * 60 * 1000,
    ...options,
  });

export const useGetDashboardStats = (options?: IQueryOptions) =>
  useQuery(["dashboard", "stats"], () => dashboardService.getDashboardStats(), {
    staleTime: 30 * 1000,
    cacheTime: 5 * 60 * 1000,
    ...options,
  });

export const useGetRecentActivities = (options?: IQueryOptions) =>
  useQuery(["dashboard", "recent-activities"], () => dashboardService.getRecentActivities(), {
    staleTime: 30 * 1000,
    cacheTime: 5 * 60 * 1000,
    ...options,
  });

export const useGetProgressChart = (options?: IQueryOptions) =>
  useQuery(["dashboard", "progress-chart"], () => dashboardService.getProgressChart(), {
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    ...options,
  });

export const useGetRecommendations = (options?: IQueryOptions) =>
  useQuery(["dashboard", "recommendations"], () => dashboardService.getRecommendations(), {
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 15 * 60 * 1000, // 15 minutes
    ...options,
  });

export const useGetDashboardLeaderboard = (options?: IQueryOptions) =>
  useQuery(["dashboard", "leaderboard"], () => dashboardService.getLeaderboard(), {
    staleTime: 60 * 1000, // 1 minute
    cacheTime: 5 * 60 * 1000,
    ...options,
  });

export const useGetGameRewardStatus = (options?: IQueryOptions) =>
  useQuery(["dashboard", "game-reward-status"], () => dashboardService.getGameRewardStatus(), {
    staleTime: 30 * 1000,
    cacheTime: 5 * 60 * 1000,
    ...options,
  });

export const useClaimDailyQuestReward = (options?: IQueryOptions) => {
  const queryClient = useQueryClient();
  return useMutation(() => dashboardService.claimDailyQuestReward(), {
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(["dashboard", "game-reward-status"]);
      if (options?.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
  });
};

export const useCreateGameSsoTicket = (options?: IQueryOptions) => {
  return useMutation(() => dashboardService.createGameSsoTicket(), {
    ...options,
  });
};
